import { createContext, useContext, useEffect, useState } from "react";

const DeliveryLocationContext = createContext(null);
const STORAGE_KEY = "qdn_delivery_location";

export function DeliveryLocationProvider({ children }) {
  const [location, setLocation] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (location) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(location));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [location]);

  return (
    <DeliveryLocationContext.Provider value={{ location, setLocation }}>
      {children}
    </DeliveryLocationContext.Provider>
  );
}

export const useDeliveryLocation = () => useContext(DeliveryLocationContext);